import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  ContentChildren,
  Input,
  QueryList,
  ViewChild,
} from '@angular/core';
import { MatStepper, StepperOrientation } from '@angular/material/stepper';

import { CdwStepComponent } from '../cdw-step/cdw-step.component';

@Component({
  selector: 'lib-cdw-stepper',
  templateUrl: './cdw-stepper.component.html',
  styleUrls: ['./cdw-stepper.component.scss'],
  standalone: false,
})
export class CdwStepperComponent implements AfterViewChecked {
  @Input() orientation: StepperOrientation = 'horizontal';

  @Input() disableHeaderButtons = false; // restrict navigation of stepper to api when true.

  @Input() completedStepIcon = 'check';

  @ContentChildren(CdwStepComponent) steps!: QueryList<CdwStepComponent>;

  @ViewChild(MatStepper) stepper!: MatStepper;

  constructor(private changeDetector: ChangeDetectorRef) {}

  ngAfterViewChecked(): void {
    this.changeDetector.detectChanges();
  }

  setStepperStep(index: number): void {
    this.stepper.selected = this.stepper.steps.get(index);

    for (let i = 0; i < index; i++) {
      const step = this.stepper.steps.get(i);
      if (step) {
        step.completed = true;
      }
    }
  }

  public previousStep(resetCurrentStep?: boolean): void {
    const currentStep = this.stepper.selected;
    this.stepper.previous();
    if (currentStep && resetCurrentStep) {
      currentStep.completed = false;
    }
  }

  nextStep(): void {
    this.stepper.next();
  }

  reset(): void {
    this.stepper.reset();
  }
}
